import { render, staticRenderFns } from "./PregnancyCheckup.vue?vue&type=template&id=46bfba58&scoped=true&"
import script from "./PregnancyCheckup.vue?vue&type=script&lang=js&"
export * from "./PregnancyCheckup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bfba58",
  null
  
)

export default component.exports